import React, { FC } from 'react';
import { transformNames } from '../../utils';
import { GW_SERVICES_PREFIXES } from '../../constants';
import {
  MessageWrapper,
  PdfIcon,
  SpeakerName,
} from './transcript.styled';
import { CardWrapper, Header, IconWrapper, MessageText } from '../transcript-common';

const { C300 } = GW_SERVICES_PREFIXES;

interface TranscriptMessage {
  message: string;
  speaker: string;
}

interface Props {
  data: TranscriptMessage[];
  callId: string;
}

export const Transcript: FC<Props> = React.memo(({ data, callId }) => {
  const handleOpenPdf = () => {
    window.open(`/${C300}/transcription_pdf/${callId}/`);
  };

  return (
    <CardWrapper>
      <Header>
        Стенограмма диалога
        <IconWrapper onClick={() => handleOpenPdf()}>
          <PdfIcon />
        </IconWrapper>
      </Header>
      <div>
        {data.map((item: TranscriptMessage, index: number) => (
          <MessageWrapper key={index}>
            <SpeakerName>{transformNames(item.speaker)}</SpeakerName>
            <MessageText>—{item.message}</MessageText>
          </MessageWrapper>
        ))}
      </div>
    </CardWrapper>
  );
});
